/**
 * CollectItem — Single collectible item visual
 *
 * Presentational component: emoji, label, quality sublabel, value.
 * Quality-colored border + subtle glow. No physics logic.
 */

export interface CollectItemData {
  id: string;
  emoji: string;
  label: string;
  sublabel?: string;
  sublabelColor?: string;
  borderColor?: string;
  glowColor?: string;
  value: number;
  size?: number;
  restitution?: number;
}

interface CollectItemProps {
  item: CollectItemData;
}

export function CollectItem({ item }: CollectItemProps) {
  const size = item.size ?? 64;

  return (
    <div
      className="flex flex-col items-center justify-center w-full h-full rounded-lg border-2 bg-gray-800/90 backdrop-blur-sm"
      style={{
        width: size,
        height: size,
        borderColor: item.borderColor ?? '#6B7280',
        boxShadow: item.glowColor
          ? `0 0 12px ${item.glowColor}40, 0 0 4px ${item.glowColor}20`
          : undefined,
      }}
    >
      <span className="text-2xl leading-none">{item.emoji}</span>
      <span
        className="text-[9px] font-medium text-gray-200 leading-tight truncate text-center mt-0.5"
        style={{ maxWidth: size - 8 }}
      >
        {item.label}
      </span>
      {item.sublabel && (
        <span
          className="text-[8px] font-semibold leading-tight"
          style={{ color: item.sublabelColor }}
        >
          {item.sublabel}
        </span>
      )}
      <span className="text-[8px] text-yellow-400 leading-tight">{item.value}g</span>
    </div>
  );
}
